export default function isPWA () {
  // chrome
  const standalone = window.matchMedia('(display-mode: standalone)').matches

  // ios safari uses navigator.standlone
  return navigator.standlone || standalone
}
